'use strict';

window.dataLayer = window.dataLayer || [];

// Inicjalizacja galerii
var galleriesHover = $('.gallery--hover').each(function () {
  var $artID = $(this).parents('.__js_stats_wrapper').data('id');
  var ga360id = $(this).data('ga360-id');

  if (ga360id === undefined) {
    console.log(
      '%c dodać ga360-id do Galerii hover: ' + $(this).data('id'),
      'background: #553311; padding: 3px; color: #ffaaaa'
    );
  } else {
    statElementCollector[ga360id + '-' + $artID] = {
      id: ga360id,
      moduleName: $(this).data('id'),
      viewedCount: 0,
      itemCount: $(this).find('.gallery--hover-item').length,
    };
  }

  $(this).statVievedSlide = [];
  slidePositionVieved[ga360id + '-' + $artID] = {};
});

// Funkcja obsługi hover/tap
var itemHover = function (item) {
  var curElement = item;
  $(item).addClass('item--active');

  setTimeout(function () {
    $(curElement).find('.gallery--hover-arrow').addClass('tapped');
  }, 500);

  if (isScrolling) return;

  var $artID = $(item).parents('.__js_stats_wrapper').data('id'),
      $galID = $(item).parents('.gallery--hover').data('id'),
      $imgID = $(item).find('.gallery--hover-img').attr('src'),
      ga360id = $(item).parents('.gallery--hover').data('ga360-id'),
      $elId = $(item).data('item');

  if (!ga360id) {
    console.log(
      '%c dodać ga360-id do patchworka!' + $galID,
      'background: #3b3b3b; padding: 3px; color: #beeb2f'
    );
  }

  var activeItem = $(item).index();
  slidePositionVieved[ga360id + '-' + $artID][activeItem] = 1;
  statElementCollector[ga360id + '-' + $artID]['viewedCount'] = Object.keys(
    slidePositionVieved[ga360id + '-' + $artID]
  ).length;

  // Wysyłka statystyk własnych
  sendStats(
    'gallery',
    (deviceTouch ? 'tap' : 'hover') + '-' + $elId,
    $artID + ' / ' + $galID,
    $imgID
  );

  // dataLayer
  if (!isScrollingFlag) {
    dataLayer.push({
      event: 'content_interaction',
      eventCategory: ga360id,
      moduleName: $galID,
      eventAction: deviceTouch ? 'tap' : 'hover'
    });
    console.log('Pushed to dataLayer:', deviceTouch ? 'tap' : 'hover');
  }
};

// Obsługa eventów
(function () {
  var eventType = deviceTouch ? 'click' : 'mouseenter';

  $('.gallery--hover').on(eventType, '.gallery--hover-item, .gallery--hover-arrow', function (ev) {
    if (deviceTouch) {
      ev.preventDefault();
      ev.stopPropagation();
    }

    var $item = $(this).closest('.gallery--hover-item');

    if (!deviceTouch) {
      // Desktop hover – usuń klasę z innych elementów
      $item.closest('.gallery--hover')
           .find('.gallery--hover-item')
           .removeClass('item--active')
           .find('.gallery--hover-arrow')
           .removeClass('tapped');
    } else {
      // Mobile – toggle aktywnego elementu
      if ($item.hasClass('item--active')) {
        $item.removeClass('item--active');
        $item.find('.gallery--hover-arrow').removeClass('tapped');
        return;
      }

      $item.closest('.gallery--hover')
           .find('.gallery--hover-item')
           .removeClass('item--active')
           .find('.gallery--hover-arrow')
           .removeClass('tapped');
    }

    itemHover($item);
  });

  // Mobile – kliknięcie poza galerią
  if (deviceTouch) {
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.gallery--hover').length) {
        $('.gallery--hover-item')
          .removeClass('item--active')
          .find('.gallery--hover-arrow')
          .removeClass('tapped');
      }
    });
  }

  // Desktop – mouseleave
  if (!deviceTouch) {
    $('.gallery--hover').on('mouseleave', '.gallery--hover-item', function () {
      $(this).removeClass('item--active');
      $(this).find('.gallery--hover-arrow').removeClass('tapped');
    });
  }
})();
